import { Link } from "react-router-dom";

const Footer = () => {
    return (
        
        <div className="footer">
            <hr />
            <p>&copy;{new Date().getFullYear()} Math-EXE | All right reserved · <Link to="/privacy">私隱政策 Privacy</Link></p>
        </div>
    );
}

export default Footer;
